import { createSlice } from "@reduxjs/toolkit";

const userCompaniesSlice = createSlice({
  name: "userCompanies",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    fetchUserCompaniesRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchUserCompaniesSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    fetchUserCompaniesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  }
});

export const {
  fetchUserCompaniesRequest,
  fetchUserCompaniesSuccess,
  fetchUserCompaniesFailure,
} = userCompaniesSlice.actions;

export default userCompaniesSlice.reducer;